import { operationLogService } from '../../services';

export const config: any = {
  getAuditReport: (params: any ) =>
    operationLogService.getAuditReport(params),
  downloadAuditReport: (params: any) =>
    operationLogService.downloadAuditReport(params),
};
